// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IChatMessagesHintsByOfferRequest,
  TChatMessagesHintsByOfferModel,
  IMappers,
  TChatMessagesHintsByOfferResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetChatHintsByOfferResponseSchema } from '../../entities/chat_hint/GetChatHintsByOfferResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createChatMessagesHintsByOfferModel(
  parameters: IChatMessagesHintsByOfferRequest,
): TChatMessagesHintsByOfferModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/chat-messages-hints-by-offer/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IChatMessagesHintsByOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IChatMessagesHintsByOfferRequest;
}

export async function fetchChatMessagesHintsByOffer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatMessagesHintsByOfferOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatMessagesHintsByOfferResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatMessagesHintsByOfferModel(parameters),
    config,
  )) as FetchResponse<TChatMessagesHintsByOfferResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetChatHintsByOfferResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatMessagesHintsByOfferResponse>;
}
